import type { CropParameterState, FreeCropParameterState } from '@ikegps/core-api';
import type { CollectionModelCropParameter } from '../cropParameter/cropParameter';
import { CollectionModelFreeCropParameter } from '../cropParameter/free.cropParameter';

function writeFreeCropParameter(cropParameter: CollectionModelFreeCropParameter): FreeCropParameterState {
	const state = cropParameter.state;

	const x = state.x;
	const y = state.y;
	const width = state.width;
	const height = state.height;

	return {
		id: state.id,
		tag: 'free',
		x,
		y,
		width,
		height,
	};
}

export class CropParameterWriter {
	static write(cropParameter: CollectionModelCropParameter): CropParameterState {
		if (CollectionModelFreeCropParameter.isFree(cropParameter)) {
			return writeFreeCropParameter(cropParameter);
		}

		throw new Error(`Unexpected drawable: ${cropParameter.id}:${cropParameter.state.tag}`);
	}
}
